<template>
    <div class="acc-row-container">
        <div class="acc-row real label__medium"
            :class="{
                        active: activeAccount.id === account.id,
                        real: !account.demo,
                        demo: account.demo,
                        'disable-bottom-border-radius' : activeAccount.id === account.id,
                    }" >
            <div class="row">
                <div class="acc-symbol">
                    <img 
                        :key="staticBase"
                        :src="getCurrencyImage(account.currency)"
                        :alt="account.currency"
                        @error="$event.target.style.display = 'none'"
                    >
                </div>
                <div class="col">
                    <span>
                        {{ accountName }}
                        {{ tokens.balanceModal.account }}
                    </span>
                    <span>CFD #{{ account.id }}</span>
                </div>
                <div class="balance">{{ currencySign(account.currency) }}{{
                        account.balance.toLocaleString('en', {
                            minimumFractionDigits: account.precision,
                            maximumFractionDigits: account.precision
                        }) }}</div>
            </div>
            <BaseRadioButton :state="activeAccount.id === account.id" :hoverDisable="true"/>
        </div>
        <AccountListItemInfo v-if="account.id === activeAccount.id"  />
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import {currencySign} from "@/common/helpers";
import BaseRadioButton from "@/new-design/shared/ui/Inputs/BaseRadioButton.vue";
import AccountListItemInfo from "@/new-design/entities/BalanceModal/ui/AccountListItemInfo.vue";

const currencies = require.context(
    '@/assets/image/currencies',
    false,
    /\.png$/
)

export default {
    name: 'AccountListItem',
    components: {BaseRadioButton,AccountListItemInfo},
    props: {
        account: {
            type: Object,
            default: () => {}
        },
    },
    computed: {
        ...mapGetters(['tokens','activeAccount','staticBase']),
        accountName() {
           return (this.account.alias && this.account.alias.toUpperCase()) ||
                    (this.account.account_name && this.account.account_name != 'MAIN' ?
                        this.account.account_name : this.account.group === 'main' ?
                            'STANDARD' : this.account.group.toUpperCase())
        }
    },
    methods: {
        currencySign,
        getCurrencyImage(name) {
            const filePath = `./${name}.png`

            if (!currencies.keys().includes(filePath)) {
                return ''
            }

            const image = currencies(filePath)

            return image.default || image
        },
    },
}

</script>

<style scoped>
.acc-row-container {
    margin-bottom: 12px;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    overflow: hidden;
}

.acc-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px;
    cursor: pointer;
    transition: background-color ease-in-out 0.3s;
    border-radius: 8px;
    background-color: var(--System-Surface4);
    color: var(--System-OnSurface);
    gap: 15px;
}

.acc-row:hover{
    background: var(--Statelayers-onsurface-opacity08);
}

.acc-row.active {
    background-color: var(--System-Surface4);
}

.acc-row .col {
    font-size: 12px;
    margin-left: 16px;
}

.acc-row .col span:last-child {
    margin-top: 2px;
    color: var(--System-OnSurfaceVariant)
}

.acc-symbol{
    min-width: 20px;
    max-width: 20px;
    min-height: 20px;
    max-height: 20px;
    img{
        width: 100%;
        height: 100%;
    }
}

.row {
    display: flex;
    align-items: center;
    width: 100%;
}

.acc-row .balance {
    font-size: 16px;
    margin-left: auto;
}

.demo .balance {
    color: var(--brand)
}

.acc-row .symbol {
    zoom:  .3;
}

.acc-row .button {
    color: var(--white-to-black);
    font-size: 1.1em;
    font-weight: 400;
    width: 120px;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--background);
    border-radius: 2px;
}

.disable-bottom-border-radius {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
}

@media (max-width: 767px) {
    .acc-row-container {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
    }
}
</style>
